import { Box } from "@mui/material";
import FormCotacao from "./form";
import banner from "../../assets/images/banner-c.png";
import { Image } from "primereact/image";

const CotacaoPage = () => {
    return <Box>
        <Image src={banner} width='100%'/>
        <FormCotacao />
    </Box>
}
export default CotacaoPage;